export const PARTNER_TIERS = ["Standard", "Premier", "Elite"] as const;

export type PartnerTier = (typeof PARTNER_TIERS)[number];

export function isPartnerTier(value: string): value is PartnerTier {
    return (PARTNER_TIERS as readonly string[]).includes(value);
}
